import React from "react";

const Footer = () => {
  return (
    <footer>
      <div>
        <h1>TechyStar</h1>
        <p>@all right reserved</p>
      </div>

      <div>
        <h5>Follow Us</h5>
        <div>
         
          <a href="https://www.linkedin.com/in/ashish-kumar-pal-a92972232/" target={"blank"}>
          Linkedin
          </a>
          <a href="https://github.com/Ashupaul" target={"blank"}>
            Github
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;